import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CategoryService } from '../../appshared/masters/category/category.service';
import { LocalStoreService } from '../service/local-store.service';
import { StyleDirectionService } from '../service/style-direction/style-direction.service';
import { AppLoaderService } from '../service/app-loader/app-loader.service';
import { CartService } from '../../appshared/invoice/cart.service';
import { TranslateService } from '@ngx-translate/core';
import { CategoryModule } from '../../appshared/masters/category/category.module';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    cartProducts;
    ComID: number = 2;


    CurrentLangSrc: string = "assets/img/flag/us-flag.jpg";
    CurrentLangName: string = "Eng";
    CurrentLangCode: string = "en";

    SecondLangSrc: string = "assets/img/flag/arab-flag.jpg";
    SecondLangName: string = "عربي";
    SecondLangCode: string = "ar";
    currentLang: string = "en";


    CurrentCurrencyName: string = "OMR";
    CurrentCurrencyCode: string = "1";

    SecondCurrencyName: string = "$";
    SecondCurrencyCode: string = "2";
    currentCurrency: string = "1";
    public SelectedLanguage: string = "en";


    // Navbar Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }
    


    constructor(
        public router: Router,
        private serv: CategoryService,
        private localS: LocalStoreService,
        public translate: TranslateService,
        private styleDir: StyleDirectionService,
        private loader: AppLoaderService,
        private elRef: ElementRef,
        private cd: ChangeDetectorRef,
        private cartService: CartService
    ) {

        this.fillCategory();

        

        this.cartService.ordersChanged.subscribe(items =>
            this.cartProducts = items
        )

        var cart = this.localS.getItem('CartItems');

        if (cart != null) {
            this.cartService.setItemsData(cart);
        }


        if (this.localS.getItem('Lang') == 'ar') {
            this.currentLang = "ar";
        }

        if (this.currentLang !== 'ar') {

            this.CurrentLangSrc = "assets/img/flag/us-flag.jpg";
            this.CurrentLangName = "Eng";
            this.CurrentLangCode = "en";

            this.SecondLangSrc = "assets/img/flag/arab-flag.jpg";
            this.SecondLangName = "عربي";
            this.SecondLangCode = "ar";
        }
        else if (this.currentLang === 'ar') {
            this.SecondLangSrc = "assets/img/flag/us-flag.jpg";
            this.SecondLangName = "Eng";
            this.SecondLangCode = "en";

            this.CurrentLangSrc = "assets/img/flag/arab-flag.jpg";
            this.CurrentLangName = "عربي";
            this.CurrentLangCode = "ar";
        }


    }

    ngOnInit(): void {
        if (this.translate.currentLang != undefined) {
            this.SelectedLanguage = this.translate.currentLang;
        }
    }



    public categoryData: CategoryModule[] | undefined;

    fillCategory() {
        // this.loader.open();
        this.serv.getService(this.ComID, 'Category')
            .subscribe((res: CategoryModule[]) => {
                this.categoryData = res;


            },
                (err: any) => {
                    //this.loader.close();
                    console.log(err);
                });
    }



    classAppliedLang = false;
    //classAppliedCurr = false;

    toggleClassLang(event: MouseEvent) {
        this.classAppliedLang = !this.classAppliedLang;
    }


    setLang(event: MouseEvent) {
        if (this.currentLang === "ar") {
            this.currentLang = "en";
        }
        else {
            this.currentLang = "ar";

        }



        this.localS.setItem('Lang', this.currentLang);
        this.toggleClassLang(event);

        window.location.reload();
    }






    isDropdownOpen = false;
    closeDropdown() {
        this.isDropdownOpen = false;
    }

    // Toggle, and prevent other click handlers from interfering
    toggleDropdown(event?: MouseEvent, force?: boolean) {
        if (event) {
            event.preventDefault();   // stop default anchor behaviour
            event.stopPropagation();  // stop bubbling to document/global handlers
        }
        this.isDropdownOpen = typeof force === 'boolean' ? force : !this.isDropdownOpen;
        // helpful when using OnPush
        try { this.cd.markForCheck(); } catch (e) { }
        console.log('isDropdownOpen ->', this.isDropdownOpen);
    }

    // Called when user clicks a category link
    onCategoryClick(event?: MouseEvent) {
        if (event) { event.stopPropagation(); }   // avoid document click closing race
        this.toggleDropdown(null, false);
        this.toggleClass(event);
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(ev: MouseEvent) {
        const target = ev.target as HTMLElement;

        if (!this.elRef.nativeElement.contains(target)) {
            this.isDropdownOpen = false;
            this.classAppliedLang = false;
            this.switcherClassApplied = false;
            this.categoryClassApplied = false;
            this.classApplied = false;

            try { this.cd.markForCheck(); } catch { }
        }
    }

    toggleLang(event: MouseEvent) {
        event.stopPropagation();   // ✔ needed for each dropdown toggle
        this.classAppliedLang = !this.classAppliedLang;
    }






    switcherClassApplied = false;
    switcherToggleClass(event: MouseEvent) {
        event.stopPropagation(); 
        this.switcherClassApplied = !this.switcherClassApplied;
    }

    classApplied = false;
    toggleClass(event: MouseEvent) {
        event.stopPropagation(); 
        this.classApplied = !this.classApplied;
    }

    categoryClassApplied = false;
    categoryToggleClass(event: MouseEvent) {
        event.stopPropagation(); 
        debugger;
        this.categoryClassApplied = !this.categoryClassApplied;
    }


    openSearch(serachName: any) {

        this.router.navigate(['shop', { serachName: serachName }]);

    }
}
